import { Box, Typography } from "@mui/material";
import CoreInput from "common/components/forms_context/CoreInput";
import CoreNumberFormat from "common/components/forms_context/CoreNumberFormat";
import { SUFFIX } from "modules/Channel/configs/constant";
import { useTranslation } from "react-i18next";

const ChannelInfo = () => {
  const { t } = useTranslation("uaa");
  return (
    <>
      <Box className="my-10">
        <Typography>{t(`header.channel-info`)}</Typography>
        <div className="grid grid-cols-1 tablet:grid-cols-3 desktop:grid-cols-4 gap-8 MuiBox-root css-0 mt-8">
          <CoreInput
            name="channelName"
            label={t(`label.channel-name`)}
            disabled
          />
          <CoreInput
            name="phoneNumber"
            label={t(`label.phone-number`)}
            disabled
          />
          <CoreInput
            name="channelType"
            label={t(`label.channel-type`)}
            disabled
          />
          <CoreInput
            name="walletState"
            label={t(`label.wallet-state`)}
            disabled
          />
          <CoreInput
            name="channelState"
            label={t(`label.channel-state`)}
            disabled
          />
          <CoreNumberFormat
            name="accountAR"
            label={t(`label.account-AR`)}
            suffix={SUFFIX.HTG}
            decimalScale={5}
            disabled
            alwaysShow
          />
          <CoreNumberFormat
            name="accountBalance"
            label={t(`label.account-balance`)}
            suffix={SUFFIX.HTG}
            decimalScale={5}
            disabled
            alwaysShow
          />
        </div>
      </Box>
    </>
  );
};

export default ChannelInfo;
